import {
  GridColumnMoneyOptionsType,
  GridColumnNumberOptionsType,
  GridColumnCommonOptionsType,
  GridColumnType,
  GridSizePropsType,
  GridSortFnType,
} from '@/ui-kit/components/grid/enums';
import { StyleSizeType } from '@/ui-kit/styles/enums';
import { CurrencyCode } from '@/ui-kit/helpers/NumberFormatHelper';
import { SoldDataTableCustomColumnKey } from '../enums';
import SoldDataTableSortService from '../../services/SoldDataTableSortService';
import { UNAVAILABLE_MESSAGE } from '../../constants';

const DEFAULT_COUNT_TRANSACTION = 1;

export const SOLD_DATA_LISTING_TABLE_COMMON_COLUMNS = [
  {
    key: SoldDataTableCustomColumnKey.Address,
    type: GridColumnType.Custom,
    title: 'Address',
    options: {
      [GridColumnCommonOptionsType.IsSticky]: true,
    },
  },
  {
    key: SoldDataTableCustomColumnKey.Transactions,
    type: GridColumnType.Custom,
    title: 'Transactions',
    options: {
      [GridColumnCommonOptionsType.EmptyCellPlaceholder]: DEFAULT_COUNT_TRANSACTION,
    },
  },
  {
    key: SoldDataTableCustomColumnKey.Year,
    type: GridColumnType.Number,
    title: 'Year',
    options: {
      [GridColumnNumberOptionsType.NumberFormat]: {
        useGrouping: false,
      },
      [GridColumnCommonOptionsType.Sortable]: {
        type: GridSortFnType.Number,
      },
    },
  },
  {
    key: SoldDataTableCustomColumnKey.Month,
    type: GridColumnType.Text,
    title: 'Month',
    options: {
      [GridColumnCommonOptionsType.Sortable]: {
        type: GridSortFnType.Custom,
        sortFns: SoldDataTableSortService.gridSortInstance,
      },
    },
  },
  {
    key: SoldDataTableCustomColumnKey.ListPrice,
    type: GridColumnType.Money,
    title: 'List Price',
    options: {
      [GridColumnMoneyOptionsType.Currency]: CurrencyCode.CanadianDollars,
      [GridColumnCommonOptionsType.Sortable]: {
        type: GridSortFnType.Number,
      },
    },
  },
  {
    key: SoldDataTableCustomColumnKey.SoldPrice,
    type: GridColumnType.Money,
    title: 'Sold Price',
    options: {
      [GridColumnMoneyOptionsType.Currency]: CurrencyCode.CanadianDollars,
      [GridColumnCommonOptionsType.Sortable]: {
        type: GridSortFnType.Number,
      },
    },
  },
  {
    key: SoldDataTableCustomColumnKey.SoldListRatio,
    type: GridColumnType.Text,
    title: 'Sold/List Ratio',
    options: {
      [GridColumnCommonOptionsType.Sortable]: {
        type: GridSortFnType.Number,
      },
    },
  },
  {
    key: SoldDataTableCustomColumnKey.BuildingTypes,
    type: GridColumnType.Text,
    title: 'Property Type',
  },
  {
    key: SoldDataTableCustomColumnKey.FinishedSqft,
    type: GridColumnType.Number,
    title: 'SqFt',
    options: {
      [GridColumnCommonOptionsType.EmptyCellPlaceholder]: UNAVAILABLE_MESSAGE,
      [GridColumnCommonOptionsType.Sortable]: {
        type: GridSortFnType.Number,
      },
    },
  },
  {
    key: SoldDataTableCustomColumnKey.TotalBeds,
    type: GridColumnType.Number,
    title: 'Beds',
    options: {
      [GridColumnCommonOptionsType.Sortable]: {
        type: GridSortFnType.Number,
      },
    },
  },
  {
    key: SoldDataTableCustomColumnKey.Baths,
    type: GridColumnType.Number,
    title: 'Baths',
    options: {
      [GridColumnCommonOptionsType.Sortable]: {
        type: GridSortFnType.Number,
      },
    },
  },
];

export const ADMIN_SOLD_DATA_LISTING_TABLE_COLUMNS = [
  ...SOLD_DATA_LISTING_TABLE_COMMON_COLUMNS,
  {
    key: SoldDataTableCustomColumnKey.Visibility,
    type: GridColumnType.Custom,
    title: '',
    options: {
      [GridColumnCommonOptionsType.EmptyCellPlaceholder]: '',
    },
  },
];

export const SOLD_DATA_DEFAULT_TABLE_SIZES = [
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.XSmall,
    [GridSizePropsType.TableSize]: StyleSizeType.XSmall,
  },
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.Small,
    [GridSizePropsType.TableSize]: StyleSizeType.XSmall,
  },
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.Medium,
    [GridSizePropsType.TableSize]: StyleSizeType.Small,
  },
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.Large,
    [GridSizePropsType.TableSize]: StyleSizeType.Small,
  },
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.XLarge,
    [GridSizePropsType.TableSize]: StyleSizeType.Small,
  },
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.XXLarge,
    [GridSizePropsType.TableSize]: StyleSizeType.Small,
  },
];
